import SearcherDestination from "./searcherDestination";
import SearcherDistribution from "./searcherDistribution";
import SearcherCalendar from "./searcherCalendar";
import SearcherValidation from "./searcherValidation";
import Searcher from "./searcher";
import SearcherSetCacheValues from "./searcherCacheValues";

export default class SearcherManager {
    constructor() {
        if ($('#form-searcher').length === 0) {
            return;
        }
        this.currentScrollPosition = 0;
        this.eventDelegation();
        this.searcher = new Searcher('form-searcher');
        this.searcherCache = new SearcherSetCacheValues();
        this.searcherValidation = new SearcherValidation(this.searcher, this.searcherCache);
        this.searcherDestination = new SearcherDestination();
        this.searcherDistribution = new SearcherDistribution(this.searcher, this.searcherValidation);
        this.searcherCalendar = new SearcherCalendar(this.searcher);
        if (this.searcherCalendar.checkSelectedDates()) {
            this.searcherCache.setCacheValues();
        } else {
            this.searcherCache.setCachedValues(this.searcherCalendar, this.searcherDistribution, this.searcherDestination);
            if (['xs','sm'].includes(myApp.deviceDetector.deviceSize)){
                this.searcherCalendar.bookingCalendarManager.resizeCalendar();
            }
        }
    }

    eventDelegation() {
        const searcherDropdown = $('[data-dropdown="searcher-dropdown"]');
        const searcherDestinationsModal = document.querySelector('#searcher-destinations-modal');

        searcherDropdown.on('show.bs.dropdown', (event) => {
            const currentTarget = $(event.currentTarget);

            if (currentTarget.attr('data-dropdown-id') === 'destination-dropdown') {
                if (searcherDestinationsModal && myApp.customModalManager) {
                    myApp.customModalManager.openModal('#searcher-destinations-modal');
                }

                const customDestinationText = document.querySelector('[name="hChollo"]');
                if (customDestinationText && customDestinationText.value) {
                    this.searcherDestination.setDestinationInputText();
                    customDestinationText.remove();
                    const searchedGroupId = document.querySelector('[name="searchedGroupId"]');
                    if (searchedGroupId) {
                        searchedGroupId.remove();
                    }
                    const searchedCholloId = document.querySelector('[name="searchedCholloId"]');
                    if (searchedCholloId) {
                        searchedCholloId.remove();
                    }
                }
            } else {
                $('[data-entity="searcher-backdrop"]').show();
                let dropdownId = currentTarget.data('dropdown-id');
                myApp.browserHistoryManager.addState('[data-dropdown-id="' + dropdownId + '"]');
            }
        });

        searcherDropdown.on('hide.bs.dropdown', (event) => {
            $('[data-entity="searcher-backdrop"]').hide();
            let dropdownId = $(event.currentTarget).data('dropdown-id');
            myApp.browserHistoryManager.removeState('[data-dropdown-id="' + dropdownId + '"]');
        });

        $('[data-searcher="open"]').on('click', () => {
            this.openSearcher();
            myApp.browserHistoryManager.addState('[data-entity="searcher-container"]');
        });

        $('[data-searcher="close"]').on('click', () => {
            myApp.browserHistoryManager.removeState('[data-entity="searcher-container"]');
        });

        $('[data-entity="searcher-container"]').on('pop-state', (event) => {
            this.closeSearcher();
            event.stopPropagation();
            event.preventDefault();
        });

        searcherDropdown.on('pop-state', (event) => {
            let currentTarget = $(event.currentTarget);
            if (currentTarget.hasClass('open')) {
                currentTarget.find('.dropdown-menu').dropdown('toggle');
                event.stopPropagation();
                event.preventDefault();
            }
        });

        if (myApp.deviceDetector.isMdScreen() || myApp.deviceDetector.isLgScreen()) {
            this.doSearchScroll();
        }

        if (myApp.browserHistoryManager && searcherDestinationsModal) {
            const modalBack = searcherDestinationsModal.querySelector('[data-element="modal-back"]');
            if (modalBack) {
                modalBack.addEventListener('click', () => {
                    myApp.customModalManager.closeModal('#searcher-destinations-modal')
                });
            }
        }
    }

    openSearcher() {
        this.currentScrollPosition = window.scrollY;
        $('[data-entity="searcher-container"]').addClass('open');
        $('body').addClass('searcher-opened');
    }

    closeSearcher() {
        $('body').removeClass('searcher-opened');
        window.scrollTo(0, this.currentScrollPosition);
        this.currentScrollPosition = 0;
        $('[data-entity="searcher-container"]').removeClass('open');
    }

    doSearchScroll() {
        let lastScrollTop = 0;
        const stickyElement = document.querySelector('[name="searcher-sticky-container"]');
        const sidebarElement = document.querySelector('#sidebar');
        const stickyContainer = document.querySelector('[name="searcher"]');
        const scrollRange = 30;
        if (!stickyContainer || stickyContainer.length === 0 || !stickyElement || stickyElement.length === 0) {
            return;
        }

        let framePending = false;

        document.addEventListener('scroll', () => {
            let scrollTop = window.scrollY;
            if (Math.abs(scrollTop - lastScrollTop) <= scrollRange) {
                return;
            }

            if (!framePending) {
                window.requestAnimationFrame(() => {
                    let containerElementPosition = stickyContainer.getBoundingClientRect();

                    if (containerElementPosition.bottom < 0) {
                        if (!stickyContainer.classList.contains('search-sticky')) {
                            stickyContainer.style.height = containerElementPosition.height + "px";
                            stickyContainer.classList.add('search-sticky');
                            stickyElement.style.top = -(stickyElement.offsetHeight + 10) + "px";
                        }
                    } else {
                        if (stickyContainer.classList.contains('search-sticky')) {
                            stickyContainer.classList.remove('search-sticky');
                            stickyContainer.style.height = '';
                            stickyElement.style.top = '';
                        }
                    }
                    if (stickyContainer.classList.contains('search-sticky')) {
                        if (scrollTop < lastScrollTop) {
                            stickyElement.style.top = '';

                            if (sidebarElement) {
                                sidebarElement.style.top = sidebarElement.classList.contains('affix-bottom') ? '' : (stickyElement.offsetHeight + 20) + "px";
                            }
                        } else {
                            stickyElement.style.top = -(stickyElement.offsetHeight + 10) + "px";

                            if (sidebarElement) {
                                sidebarElement.style.top = '';
                            }
                        }
                    }
                    lastScrollTop = scrollTop;
                    framePending = false;
                });

                framePending = true;
            }
        });
    }

    static get inputs() {
        return {
            formId: '#form-searcher',
            start: 'inicio',
            end: 'fin',
            bookingDates: '#booking-dates',
            adults: 'nA',
            children: 'nNe',
            childrenAges: 'edN',
            rooms: 'ha'
        }
    }
}
